import React from 'react';
import { LayoutDashboard, RotateCcw, FileText, BookOpen, Clock, LogOut, Landmark, ScrollText } from 'lucide-react';
type Page = 'dashboard' | 'repayments' | 'applications' | 'glpostings' | 'scheduler' | 'activitylog';
interface SidebarProps {
  currentPage: Page;
  onNavigate: (page: Page) => void;
  onLogout: () => void;
}
export function Sidebar({
  currentPage,
  onNavigate,
  onLogout
}: SidebarProps) {
  const navItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: LayoutDashboard
  }, {
    id: 'repayments',
    label: 'Repayments',
    icon: RotateCcw
  }, {
    id: 'applications',
    label: 'Applications',
    icon: FileText
  }, {
    id: 'glpostings',
    label: 'GL Postings',
    icon: BookOpen
  }, {
    id: 'scheduler',
    label: 'Scheduler Logs',
    icon: Clock
  }, {
    id: 'activitylog',
    label: 'Activity Log',
    icon: ScrollText
  }] as const;
  return <aside className="w-64 bg-white border-r border-gray-200 flex flex-col h-screen fixed left-0 top-0 z-10" data-id="element-515">
      {/* Header */}
      <div className="h-16 flex items-center px-6 border-b border-gray-100" data-id="element-516">
        <Landmark className="h-6 w-6 text-blue-700 mr-3" data-id="element-517" />
        <span className="text-lg font-bold text-gray-900 tracking-tight" data-id="element-518">
          LMS Admin
        </span>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-6 space-y-1 overflow-y-auto" data-id="element-519">
        {navItems.map(item => {
        const isActive = currentPage === item.id;
        const Icon = item.icon;
        return <button key={item.id} onClick={() => onNavigate(item.id)} className={`
                w-full flex items-center px-3 py-2.5 text-sm font-medium rounded-md transition-colors duration-150
                ${isActive ? 'bg-blue-50 text-blue-700 border-l-4 border-blue-700 pl-2' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 border-l-4 border-transparent pl-2'}
              `} data-id="element-520">
              <Icon className={`mr-3 h-5 w-5 ${isActive ? 'text-blue-700' : 'text-gray-400 group-hover:text-gray-500'}`} data-id="element-521" />
              {item.label}
            </button>;
      })}
      </nav>

      {/* Footer / Logout */}
      <div className="p-4 border-t border-gray-200" data-id="element-522">
        <button onClick={onLogout} className="w-full flex items-center px-3 py-2 text-sm font-medium text-gray-500 rounded-md hover:text-red-600 hover:bg-red-50 transition-colors" data-id="element-523">
          <LogOut className="mr-3 h-5 w-5" data-id="element-524" />
          Sign Out
        </button>
      </div>
    </aside>;
}